var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ComConfig", {
    attrs: {
      title: "图片列表-2",
      component_name: "4-2-img-list-2",
      initConfigNum: 3,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }